import Vue from 'vue'
import Router from 'vue-router'
const _import = require('./_import_' + process.env.NODE_ENV)
Vue.use(Router)
// router开发先这么写后续会改成接口动态获取
// control 控制台          dataCenter数据中心
const RouterMap = [
  { path: '/login', name: 'login', component: _import('login/index') }
]
const error = [
  { path: '/404', component: _import('errorPage/404'), name: '404' }
]
const emptyRole = [
  { path: '/empty-role', components: {
    nav: _import('layout/mainNav'),
    default: _import('emptyRole/index')
  }, name: 'emptyRole' }
]
// 代理 - 用户管理
const agentusers = [
  {
    path: '/agentuser',
    name: 'agentuser',
    meta: {
      menuName: '用户管理'
    },
    component: _import('layout/normalLayout'),
    children: [
      { meta: { menuName: '工业列表' }, path: 'industry', name: 'agentind', component: _import('agent/list') },
      { meta: { menuName: '服务商列表' }, path: 'service', name: 'agentser', component: _import('agent/list') }
    ]
  }
]
const exchangecard = [
  {
    path: '/exchangecard',
    name: 'exchangecard',
    meta: {
      menuName: '兑换卡'
    },
    component: _import('layout/normalLayout'),
    children: [
      { meta: { menuName: '礼包兑换' }, path: 'cardlist', name: 'cardlist', component: _import('exchangecard/list') },
      { meta: { menuName: '工具兑换' }, path: 'toollist', name: 'toollist', component: _import('exchangecard/toollist') }
    ]
  }
]
// 渠道管理
const channel = [
  {
    path: '/channel',
    name: 'channel',
    redirect: '/channel/channel-list',
    component: _import('layout/normalLayout'),
    children: [
      { meta: { menuName: '渠道列表' }, path: 'channel-list', name: 'channelList', component: _import('channel/list') }
    ]
  }
]
// 用户管理
const users = [
  {
    path: '/users',
    name: 'users',
    component: _import('layout/normalLayout'),
    children: [
      { meta: { menuName: '工业列表' }, path: 'industry-list', name: 'industryList', component: _import('users/list') },
      { meta: { menuName: '工业认证管理' }, path: 'industry-verify/:type', name: 'industryVerify', component: _import('users/verify') },
      { meta: { menuName: '服务商列表' }, path: 'server-list', name: 'serverList', component: _import('users/listser') },
      { meta: { menuName: '服务商认证管理' }, path: 'server-verify/:type', name: 'serverVerify', component: _import('users/verify') },
      { meta: { menuName: '审核进度跟踪' }, path: 'verify-progress', name: 'verifyProgress', component: _import('users/verifyProgress') },
      { meta: { menuName: '用户手续费管理' }, path: 'user-fee-manger', name: 'userFeeManger', component: _import('users/userFeeManger') }
    ]
  },
  {
    path: '/detail',
    name: 'detail',
    component: _import('layout/returnLayout'),
    children: [
      { meta: { menuName: '工业列表' }, path: 'detail-list-industry/:id', name: 'detailListIndustry', component: _import('users/detailList') },
      { meta: { menuName: '服务商列表' }, path: 'detail-list-server/:id', name: 'detailListServer', component: _import('users/detailList') },
      { meta: { menuName: '工业列表' }, path: 'detail-info-industry', name: 'detailInfoIndustry', component: _import('users/detailInfo') },
      { meta: { menuName: '服务商列表' }, path: 'detail-info-server', name: 'detailInfoServer', component: _import('users/detailInfo') },
      { meta: { menuName: '工业列表' }, path: 'detail-info-edit-industry', name: 'detailInfoEditIndustry', component: _import('users/detailInfo') },
      { meta: { menuName: '服务商列表' }, path: 'detail-info-edit-server', name: 'detailInfoEditServer', component: _import('users/detailInfo') },
      { meta: { menuName: '工业认证管理' }, path: 'detail-verify-industry/:id', name: 'detailVerifyIndustry', component: _import('users/verifyDetailList') },
      { meta: { menuName: '服务商认证管理' }, path: 'detail-verify-server/:id', name: 'detailVerifyServer', component: _import('users/verifyDetailList') },
      { meta: { menuName: '工业列表' }, path: 'userfee/:id', name: 'addOrEditFee', component: _import('users/addOrEditFee') }
    ]
  },
  {
    path: '/company',
    name: 'company',
    component: _import('layout/returnLayout'),
    children: [
      { meta: { menuName: '工业列表' }, path: 'company-add-industry', name: 'companyAddIndustry', component: _import('users/addCompany') },
      { meta: { menuName: '服务商列表' }, path: 'company-add-server', name: 'companyAddServer', component: _import('users/addCompany') },
      { meta: { menuName: '工业列表' }, path: 'company-edit-industry/:id', name: 'companyEditIndustry', component: _import('users/editCompany') },
      { meta: { menuName: '服务商列表' }, path: 'company-edit-server/:id', name: 'companyEditServer', component: _import('users/editCompany') }
    ]
  }
]
// 交易管理
const trade = [{
  path: '/trade',
  name: 'trade',
  component: _import('layout/normalLayout'),
  children: [
    { meta: { menuName: '会员支付宝流水查询' }, path: 'ali-payment', name: 'aliPayment', component: _import('trade/index') },
    { meta: { menuName: '会员转账交易审核' }, path: 'vip-payment', name: 'vipPayment', component: _import('trade/index') },
    { meta: { menuName: 'UKEY付款流水查询' }, path: 'ukey-payment', name: 'ukeyPayment', component: _import('trade/index') },
    { meta: { menuName: '交易服务费流水查询' }, path: 'tran-service', name: 'tranService', component: _import('trade/index') },
    { meta: { menuName: '充值流水查询' }, path: 'recharge', name: 'recharge', component: _import('trade/index') },
    { meta: { menuName: '提现流水查询' }, path: 'withdrawal', name: 'withdrawal', component: _import('trade/index') },
    { meta: { menuName: '付款流水查询' }, path: 'payment', name: 'payment', component: _import('trade/index') },
    { meta: { menuName: '收款流水查询' }, path: 'receivable', name: 'receivable', component: _import('trade/index') },
    { meta: { menuName: '账户互转流水查询' }, path: 'same-trade-detail', name: 'sameTradeDetail', component: _import('trade/index') }
    // { meta: { menuName: '调研报告流水查询' }, path: 'report-search', name: 'reportSearch', component: _import('trade/index') }
  ]
}, {
  path: '/trade-detail',
  redirect: '/trade-detail/check-vip/0',
  name: 'tradeRe',
  component: _import('layout/returnLayout'),
  children: [{
    path: 'check-vip/:status/:order_no', name: 'checkVip', component: _import('trade/checkVip')
  }]
}]
// 北京发票
const invoiceBeijing = [{
  path: '/invoiceBeijing',
  name: 'invoiceBeijing',
  component: _import('layout/normalLayout'),
  children: [
    { meta: { menuName: '开票申请' }, path: 'invoiceApplyBj/:type', name: 'invoiceApplyBj', component: _import('invoiceManage/index') },
    { meta: { menuName: '开票记录' }, path: 'invoiceRecordBj/:type', name: 'invoiceRecordBj', component: _import('invoiceManage/index') },
    { meta: { menuName: '作废记录' }, path: 'invoiceDiscardBj/:type', name: 'invoiceDiscardBj', component: _import('invoiceManage/index') }
  ]
}, {
  path: '/invoiceDetail',
  name: 'invoiceDetail',
  component: _import('layout/returnLayout'),
  children: [{
    path: 'invoiceDetailPage/:changeType/:operate/:type/:id', name: 'invoiceDetailPage', component: _import('invoiceManage/invoiceDetailPage')
  }]
}]
// 贵阳发票
const invoiceGuiyang = [{
  path: '/invoiceGuiyang',
  name: 'invoiceGuiyang',
  component: _import('layout/normalLayout'),
  children: [
    { meta: { menuName: '开票申请' }, path: 'invoiceApplyGy/:type', name: 'invoiceApplyGy', component: _import('invoiceManage/index') },
    { meta: { menuName: '开票记录' }, path: 'invoiceRecordGy/:type', name: 'invoiceRecordGy', component: _import('invoiceManage/index') },
    { meta: { menuName: '作废记录' }, path: 'invoiceDiscardGy/:type', name: 'invoiceDiscardGy', component: _import('invoiceManage/index') }
  ]
}, {
  path: '/invoiceDetail',
  name: 'invoiceDetail',
  component: _import('layout/returnLayout'),
  children: [{
    path: 'invoiceDetailPage/:invoiceType/:operate/:type/:id', name: 'invoiceDetailPage', component: _import('invoiceManage/invoiceDetailPage')
  }]
}]
// 对账中心
const duizhang = [{
  path: '/duizhang',
  name: 'duizhang',
  component: _import('layout/normalLayout'),
  children: [
    { meta: { menuName: '收款流水查询' }, path: 'receivableAccount', name: 'receivableAccount', component: _import('trade/index') }
  ]
}]
// 内容管理，控制台布局页面
const content = [
  {
    path: '/content',
    redirect: '/content/single-clean',
    name: 'content',
    component: _import('layout/normalLayout'),
    children: [
      { path: 'single-clean', name: 'singleClean', meta: { menu: 'singleClean' }, component: _import('content/singleClean') },
      { path: 'unsure-clean', name: 'unsureClean', meta: { menu: 'singleClean' }, component: _import('content/singleClean') },
      { path: 'all-clean', name: 'allClean', meta: { menu: 'allClean' }, component: _import('content/allClean') },
      { path: 'standard-lib/:type', name: 'standardLib', meta: { menu: 'standardLib' }, component: _import('content/standardLib') },
      { path: 'classes', name: 'classes', meta: { menu: 'classes' }, component: _import('content/classes') }
    ]
  },
  {
    path: '/contentClean',
    redirect: '/contentClean/cleanList',
    name: 'contentRe',
    component: _import('layout/returnLayout'),
    children: [{
      path: 'clean-list', name: 'cleanList', component: _import('content/cleanList')
    }, {
      path: 'add-lib/:type', name: 'addLib', component: _import('content/editLib')
    }, {
      path: 'edit-lib/:type/:id', name: 'editLib', component: _import('content/editLib')
    }]
  }
]
// 结算管理
const settle = [{
  path: '/settle',
  redirect: '/settle/accounts',
  name: 'settle',
  component: _import('layout/normalLayout'),
  children: [
    { meta: { menuName: '平台账户查询', menu: 'accounts' }, path: 'accounts', name: 'accounts', component: _import('settle/accounts') },
    { meta: { menuName: '已绑定银行卡信息', menu: 'cards' }, path: 'cards', name: 'cards', component: _import('settle/cards') },
    { meta: { menuName: '资金总收付统计', menu: 'fundCount' }, path: 'fund-count/:index', name: 'fundCount', component: _import('settle/fundCount') }
  ]
}]
// 流量管理
const flow = [{
  path: '/flow',
  redirect: '/flow/live',
  name: 'flow',
  component: _import('layout/normalLayout'),
  children: [
    { meta: { menuName: '直播数流水查询', menu: 'live' }, path: 'live/:type', name: 'live', component: _import('flow/live') },
    { meta: { menuName: '会议室流水查询', menu: 'meeting' }, path: 'meeting/:type', name: 'meeting', component: _import('flow/meeting') },
    { meta: { menuName: '调研流水查询', menu: 'diaoyan' }, path: 'diaoyan/:type', name: 'diaoyan', component: _import('flow/diaoyan') },
    { meta: { menuName: '调研报告流水查询', menu: 'reportSearch' }, path: 'report-search', name: 'reportSearch', component: _import('trade/index') },
    { meta: { menuName: '调研报告流水查询', menu: 'reportSearch' }, path: 'report-terminal', name: 'reportTerminal', component: _import('trade/index') }
  ]
}, {
  path: '/flowDetail',
  name: 'flowDetail',
  component: _import('layout/returnLayout'),
  children: [
    { path: '/flowcheck/:type/:id', name: 'flowcheck', component: _import('flow/flowDetail') },
    { path: '/flowscan/:type/:id', name: 'flowscan', component: _import('flow/flowDetail') }
  ]
}
]
// 发票管理，控制台布局页面
const invoice = [
  {
    path: '/invoice',
    redirect: '/invoice/billing',
    name: 'invoice',
    component: _import('layout/normalLayout'),
    children: [
      { meta: { menuName: '历史开具发票', menu: 'vipInvoice' }, path: 'vip-invoice', name: 'vipInvoice', component: _import('invoice/invoiceList') },
      { meta: { menuName: '历史开具发票', menu: 'vipInvoice' }, path: 'ukey-invoice', name: 'ukeyInvoice', component: _import('invoice/invoiceList') },
      { meta: { menuName: '历史开具发票', menu: 'vipInvoice' }, path: 'fee-invoice', name: 'feeInvoice', component: _import('invoice/invoiceList') },
      { meta: { menuName: '发票信息审核(工业)', menu: 'examinei' }, path: 'examinei', name: 'examinei', component: _import('invoice/examine') },
      { meta: { menuName: '发票信息审核(服务商)', menu: 'examines' }, path: 'examines', name: 'examines', component: _import('invoice/examine') }
    ]
  },
  {
    path: '/invoiceRe',
    redirect: '/invoice/edit',
    name: 'invoiceRe',
    component: _import('layout/returnLayout'),
    children: [
      { meta: { menuName: '历史开具发票' }, path: 'detail/:type/:id', name: 'invoiceDetail', component: _import('invoice/detail') },
      { meta: { menuName: '历史开具发票' }, path: 'makeout/:type/:id', name: 'makeout', component: _import('invoice/detail') },
      { meta: { menuName: '发票信息审核(工业)' }, path: 'examine-detail/:id/:type', name: 'examineDetail', component: _import('invoice/invoiceInfo') },
      { meta: { menuName: '发票信息审核(工业)' }, path: 'invoice-info/:id/:type', name: 'invoiceInfo', component: _import('invoice/invoiceInfo') },
      { meta: { menuName: '发票信息审核(服务商)' }, path: 'invoice-info/:id/:type', name: 'invoiceInfo', component: _import('invoice/invoiceInfo') }
    ]
  }
]
// 会员管理
const member = [
  {
    path: '/member',
    redirect: '/member/permission',
    name: 'member',
    component: _import('layout/normalLayout'),
    children: [
      // 新增会员流水
      { meta: { menuName: '会员流水查询', menu: 'memberBill' }, path: '/member/memberBill/:type', name: 'memberBill', component: _import('member/bill') },
      { meta: { menuName: '权限管理', menu: 'memberPermission' }, path: 'permission', name: 'memberPermission', component: _import('member/permission') },
      { meta: { menuName: '会员申请', menu: 'memberApplication' }, path: 'application', name: 'memberApplication', component: _import('member/application') },
      { meta: { menu: 'memberConfig' }, path: 'urlconfig', name: 'memberConfig', component: _import('member/urlconfig') }
    ]
  },
  {
    path: '/memberRe',
    redirect: '/memberRe/edit/0',
    name: 'memberRe',
    component: _import('layout/returnLayout'),
    children: [
      { meta: { menuName: '权限管理' }, path: 'edit/:id', name: 'memberReEdit', component: _import('member/edit') }
    ]
  }
]
// 产品标准库
const goodStand = [
  {
    path: '/goodstand',
    name: 'goodstand',
    component: _import('layout/normalLayout'),
    children: [
      {
        path: 'jiyaoData/:type',
        name: 'jiyaoData',
        meta: { menuName: '中国基药数据库', menu: 'jiyaoData', factory: 'standLib' },
        component: _import('allDataStand/index')
      },
      {
        path: 'guochanData/:type',
        name: 'guochanData',
        meta: { menuName: '国产药品数据库', menu: 'guochanData', factory: 'standLib' },
        component: _import('allDataStand/index')
      },
      {
        path: 'jinkouData/:type',
        name: 'jinkouData',
        meta: { menuName: '进口药品数据库', menu: 'jinkouData', factory: 'standLib' },
        component: _import('allDataStand/index')
      },
      {
        path: 'yibaoData/:type',
        name: 'yibaoData',
        meta: { menuName: '中国医保数据库', menu: 'yibaoData', factory: 'standLib' },
        component: _import('allDataStand/index')
      }
    ]
  },
  {
    path: '/qiyeStand',
    name: 'qiyeStand',
    component: _import('layout/normalLayout'),
    children: [
      {
        path: 'kehuData/:type',
        name: 'kehuData',
        meta: { menuName: '客户主数据库', menu: 'kehuData', factory: 'standLib' },
        component: _import('allDataStand/index')
      },
      {
        path: 'companyData/:type',
        name: 'companyData',
        meta: { menuName: '生产企业数据库', menu: 'companyData', factory: 'standLib' },
        component: _import('allDataStand/index')
      },
      {
        path: 'shangyeData/:type',
        name: 'shangyeData',
        meta: { menuName: '中国商业数据库', menu: 'shangyeData', factory: 'standLib' },
        component: _import('allDataStand/index')
      },
      {
        path: 'yiliaoData/:type',
        name: 'yiliaoData',
        meta: { menuName: '中国医疗机构库', menu: 'yiliaoData', factory: 'standLib' },
        component: _import('allDataStand/index')
      },
      {
        path: 'yaodianData/:type',
        name: 'yaodianData',
        meta: { menuName: '中国药店数据库', menu: 'yaodianData', factory: 'standLib' },
        component: _import('allDataStand/index')
      },
      {
        path: 'yiyuanData/:type',
        name: 'yiyuanData',
        meta: { menuName: '中国医院数据库', menu: 'yiyuanData', factory: 'standLib' },
        component: _import('allDataStand/index')
      },
      {
        path: 'zhongduanData/:type',
        name: 'zhongduanData',
        meta: { menuName: '第三终端数据库', menu: 'zhongduanData', factory: 'standLib' },
        component: _import('allDataStand/index')
      }
    ]
  },
  {
    path: '/medicienStand',
    name: 'goomedicienStanddstand',
    component: _import('layout/normalLayout'),
    children: [
      {
        path: 'doctorData/:type',
        name: 'doctorData',
        meta: { menuName: '医生数据库', menu: 'doctorData', factory: 'standLib' },
        component: _import('allDataStand/index')
      }
    ]
  },
  {
    path: '/dataOpe',
    name: 'dataOpe',
    component: _import('layout/returnLayout'),
    children: [
      {
        path: 'addData/:type/:id/:tabType',
        name: 'addData',
        meta: { menu: 'addData', factory: 'standLib' },
        component: _import('allDataStand/addAndEditData')
      },
      {
        path: 'editData/:type/:id/:tabType',
        name: 'editData',
        meta: { menu: 'editData', factory: 'standLib' },
        component: _import('allDataStand/addAndEditData')
      },
      {
        path: 'fixData/:type/:id',
        name: 'fixData',
        meta: { menu: 'fixData', factory: 'standLib' },
        component: _import('allDataStand/errFixed')
      },
      // 客户主数据新增审核页面
      {
        path: 'customDataCheck/:id/:type',
        name: 'customDataCheck',
        mata: { menu: 'customDataCheck', factory: 'standLib' },
        component: _import('allDataStand/customDataCheck')
      },
      // 客户主数据纠错审核页面
      {
        path: 'customJiuCheck/:id',
        name: 'customJiuCheck',
        mata: { menu: 'customJiuCheck', factory: 'standLib' },
        component: _import('allDataStand/customJiuCheck')
      },
      // 客户主数据删除审核页面
      {
        path: 'customDelCheck/:id',
        name: 'customDelCheck',
        mata: { menu: 'customDelCheck', factory: 'standLib' },
        component: _import('allDataStand/customDelCheck')
      }
    ]
  }
]
// 统计结算
const tongsettle = [{
  path: '/tongsettle',
  name: 'tongsettle',
  meta: {
    menuName: '统计结算'
  },
  component: _import('layout/normalLayout'),
  children: [
    {
      path: 'month',
      name: 'settlemonth',
      meta: { menuName: '月账单', menu: 'settlemonth', factory: 'report', noPage: true },
      component: _import('tongsettle/month')
    },
    {
      path: 'history',
      name: 'settlehistory',
      meta: { menuName: '交易记录', menu: 'settlehistory', factory: 'report', noPage: true },
      component: _import('tongsettle/history')
    }
  ]
}]

// --- 运营报告 ---
// 财务分析
const finacial = [{
  path: '/finacial',
  name: 'finacial',
  component: _import('layout/normalLayout'),
  children: [
    {
      path: 'trade-flow/:type',
      name: 'finacialTradeFlow',
      meta: { menuName: '财务分析', menu: 'finacialTradeFlow', factory: 'report', noPage: true },
      component: _import('report/finacial')
    }
  ]
}]
const finacialRe = [{
  path: '/finacial-detail',
  name: 'finacialDetail',
  component: _import('layout/returnLayout'),
  children: [
    {
      menuName: '交易汇总',
      path: 'trade-flow-detail/:type/:date',
      name: 'finacialTradeFlowDetail',
      meta: { menuName: '财务分析' },
      component: _import('report/finacialDetail')
    }
  ]
}]
const report = [].concat(finacial, finacialRe)

// 账户权限
const account = {
  path: '/account',
  name: 'account',
  component: _import('layout/returnLayout'),
  children: [
    { meta: { isAdmin: true }, path: 'add-account', name: 'addAccount', component: _import('account/addAccount') },
    { meta: { isAdmin: true }, path: 'edit-account', name: 'editAccount', component: _import('account/editAccount') },
    { meta: { isAdmin: true }, path: 'account-list', name: 'accountList', component: _import('account/accountPermission') },
    { meta: { isAdmin: true }, path: 'jurisdiction-set', name: 'jurisdictionSet', component: _import('account/accountPermission') },
    { meta: { isAdmin: true }, path: 'edit-jurisdiction', name: 'editJurisdiction', component: _import('account/jurisdictionAction') },
    { meta: { isAdmin: true }, path: 'add-jurisdiction', name: 'addJurisdiction', component: _import('account/jurisdictionAction') },
    { path: 'new-password', name: 'newPassword', component: _import('account/newPassword') }
  ]
}

export const constantRouterMap = RouterMap.concat(
  { path: '/' },
  emptyRole,
  error
)
export const asyncRouterMap = [].concat(
  agentusers,
  exchangecard,
  tongsettle,
  report,
  channel,
  users,
  trade,
  content,
  settle,
  invoice,
  member,
  goodStand,
  account,
  invoiceBeijing,
  invoiceGuiyang,
  duizhang,
  flow,
  { path: '*', redirect: '/404' }
)

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
